import {Injectable} from '@angular/core';
import {EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import {PriceList} from './model';

export interface PriceListState extends EntityState<PriceList> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'PriceList' })
export class Store extends EntityStore<PriceListState> {

  constructor() {
    super();
  }

}
